import script from "./ManagerCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerCompany.vue?vue&type=script&setup=true&lang=js"

import "./ManagerCompany.vue?vue&type=style&index=0&id=00b657e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b657e3"]])

export default __exports__